import { ItemRequestJsEnv } from '../models/item_request_js_env'

export class ItemRequest {
  constructor(private model: ItemRequestJsEnv) {
    this.model = { ...model };
  }

  updateModel(newModel: ItemRequestJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): ItemRequestJsEnv {
    return {
      ...this.model
    };
  }

  setIsSendSuccess(isSendSuccess: boolean): void {
    this.model.isSendSuccess = isSendSuccess;
    this.model.isFirstView = false;
  }

  setIsSendFailed(isSendFailed: boolean): void {
      this.model.isSendFailed = isSendFailed;
      this.model.isFirstView = false;
  }
}
